import * as React from 'react';
import PropTypes from 'prop-types';
import { Table, Card } from '@beehive/components';
import { SUPPLIER_EMPLOYEES_KEYS_MAPPING } from '../utils';
import { defaultColumnRender } from 'utils/table';
import messages from 'messages/CompanyManagement';

const COLUMN_KEYS = ['user_login', 'status', 'user_name', 'user_email', 'user_popo'];

export default class SupplierEmployees extends React.Component<any, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  private getRowClassName = (r: any) => {
    if (r.status === 'locked') {
      return 'color-disabled';
    } else {
      return '';
    }
  }

  private getColumnsRender = () => {
    const { intl } = this.context;
    return {
      status: (v: any, r: any, i: number) => {
        return intl.formatMessage(messages.status, { status: r.status });
      },
    };
  }

  private getColumns = () => {
    const { intl } = this.context;
    return COLUMN_KEYS.map((key: string) => {
      const column = SUPPLIER_EMPLOYEES_KEYS_MAPPING[key];
      const columnsRender = this.getColumnsRender();
      const columnProps = column.showProps || {};
      return {
        key,
        dataIndex: key,
        title: intl.formatMessage(messages[key], { status: undefined }),
        render: columnsRender[key] || defaultColumnRender,
        width: 150,
        ...columnProps,
      };
    });
  }

  public render() {
    const { intl } = this.context;
    const { loading, supplier_employees = [] } = this.props;
    const columns = this.getColumns();

    return (
      <Card
        titleNode={intl.formatMessage(messages.accountsInfo)}
        className={'employees-info-show'}
        loading={loading}
      >
        <Table
          data={supplier_employees}
          columns={columns}
          rowKey={(row: any) => row.id}
          rowClassName={this.getRowClassName}
        />
      </Card>
    );
  }
}
